import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { SelectOptionsInterface } from '../../types';

import { KeeniconComponent } from '../keenicon/keenicon.component';

@Component({
  selector: 'ui-selected-items',
  imports: [KeeniconComponent],
  templateUrl: './selected-items.component.html',
  styleUrl: './selected-items.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectedItemsComponent {
  items = input<SelectOptionsInterface[]>([]);
  removeItem = output<string>();

  onRemoveItem(itemId: string): void {
    this.removeItem.emit(itemId);
  }
}
